import type { FC, PropsWithChildren } from "react";
import React from "react";

import cn from "classnames";

import type {
    PropsWithCustomVarsStyles,
    PropsWithTsId,
} from "../../../types/react";
import type { IToastCommonProps } from "../helper/ToastCommon";

import classes from "./CustomToast.styl";

const CUSTOM_TOAST_TEST_ID = "customToast-test-id";
const CUSTOM_TOAST_DISPLAY_NAME = "CustomToast";

export type CustomToastProps = PropsWithCustomVarsStyles<
    Pick<IToastCommonProps, "timer" | "fillHorizontal" | "timerDuration">
> &
    Partial<PropsWithTsId>;

/**
 * Используется библиотека sonner.
 *
 * <a href="https://uikit.odkl.ru/?path=/docs/%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B-toast-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D0%B0-toast--docs" target="_blank">Дока про использование компонента Toast</a>
 *
 * Компонент, который в виде всплывающего сообщения, отображает для пользователя информацию об изменениях в приложении и даёт возможность выполнить контекстное действие (кастомная версия компонента (внутрь можно положить что угодно))
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=2-88973&p=f&m=dev" target="_blank">Спека</a>
 * @constructor
 */

export const CustomToast: FC<PropsWithChildren<CustomToastProps>> = (props) => {
    const {
        "data-tsid": tsid,
        timer = false,
        children,
        fillHorizontal = false,
        customVarsStyles,
        timerDuration = 4000,
    } = props;

    const dataTestId = tsid || CUSTOM_TOAST_TEST_ID;

    const wrapperClassName = cn(
        classes["wrapper"],
        fillHorizontal && classes["__fill-horizontal"],
        customVarsStyles,
    );

    const duration = `${timerDuration}ms`;

    return (
        <div
            data-tsid={dataTestId}
            data-uikit={CUSTOM_TOAST_DISPLAY_NAME}
            className={wrapperClassName}
            role="alert"
        >
            {timer && (
                <div className={classes["main-timer"]}>
                    <div
                        className={classes["timer"]}
                        style={{
                            ["--duration" as any]: duration,
                        }}
                    ></div>
                    <div
                        className={classes["timer-glow"]}
                        style={{
                            ["--duration" as any]: duration,
                        }}
                    />
                </div>
            )}
            {children}
        </div>
    );
};

CustomToast.displayName = "CustomToast";

export default CustomToast;
